<template>
  <div class="full-width full-height">
    <div class="q-col-gutter-x-lg q-col-gutter-y-xs">
      <div v-if="organizationalStructureLevel.length > 0">
        <q-card-section class="q-px-lg q-col-gutter-x-md row">
          <span
            v-for="(item, index) in organizationalStructureLevel"
            :key="item.id"
            class="col-4"
          >
            <jt-select
              :ref="`select-${index}`"
              :key="item.id"
              v-model="item.value"
              :options="getOptions(item.list, index)"
              emit-value
              map-options
              clearable
              outlined
              @input="onSelectChange(item.organizationalStructureLevel)"
              :float-label="item.label"
            />
          </span>
        </q-card-section>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { QScrollArea } from 'quasar'
import { JtSelect } from 'jtech-webcomps'

@Component({
  name: 'organizationalStructureSearch',
  mixins: [JtSelect],
  components: { QScrollArea, JtSelect }
})
class OrganizationalStructureSearch extends Vue {
  organizationalStructureLevelCombos = []
  action = 'organizationalStructure.compnentSearch'

  async mounted () {
    const data = await repository.resolveLogic(this.action, {
      organizationalStructure: this.value
    })
    this.createOrganizationalStructureCombo(data)
  }

  createOrganizationalStructureCombo (data) {
    const { organizationalStructureIds, level } = data
    if (level) {
      this.organizationalStructureLevelCombos = JSON.parse(level)
    }
    if (organizationalStructureIds) {
      const ids = organizationalStructureIds.split(',').reverse()
      this.organizationalStructureLevelCombos.forEach((combo, index) => {
        if (ids[index]) {
          combo.value = parseInt(ids[index])
        }
      })
    }
  }

  get organizationalStructureLevel () {
    return this.organizationalStructureLevelCombos
  }

  getOptions (list, index) {
    let parentId = ''
    if (index > 0) {
      parentId = this.organizationalStructureLevelCombos[index - 1].value
    }
    const options = list
      .filter((e) => !e.parentId || e.parentId == parentId)
      .flatMap((element) => [{ value: element.id, label: element.name }])
    return options
  }

  onSelectChange (organizationalStructureLevel) {
    this.organizationalStructureLevelCombos.forEach((e, index) => {
      if (e.organizationalStructureLevel > organizationalStructureLevel) {
        delete e.value
      } else if (e.value) {
        this.__set(e.value)
      }
    })
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  }
}
export default OrganizationalStructureSearch
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
</style>
